const actions = {
    CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGOUT: 'LOGOUT',
    SESSION_RESET_REQUEST: 'SESSION_RESET_REQUEST',
    SESSION_RESET: 'SESSION_RESET',
    SESSION_RESET_SUCCESS: 'SESSION_RESET_SUCCESS',
    SESSION_RESET_REMOTE: 'SESSION_RESET_REMOTE',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    SELECT_USERPERMISSIONS: 'SELECT_USERPERMISSIONS',
    IPADDRESS: 'IPADDRESS',
    USERINFO_UPDATE_REQUEST: 'USERINFO_UPDATE_REQUEST',
    USERINFO_UPDATE_SUCCESS: 'USERINFO_UPDATE_SUCCESS',
    UPDATE_TOKEN: 'UPDATE_TOKEN',
    USER_UPDATE: 'USER_UPDATE',

    updateToken: (access, refresh, accessTokenExpiration, refreshTokenExpiration) => ({
        type: actions.UPDATE_TOKEN,
        payload: {access, refresh, accessTokenExpiration, refreshTokenExpiration}
    }),
    checkAuthorization: () => ({type: actions.CHECK_AUTHORIZATION}),
    login: (tokens) => ({
        type: actions.LOGIN_REQUEST,
        payload: {tokens},
    }),
    logout: (refresh, authToken) => ({
        type: actions.LOGOUT,
        payload: {refresh, authToken},
    }),
    sessionResetRequest: (reason) => ({
        type: actions.SESSION_RESET_REQUEST,
        payload: {reason},
    }),
    sessionReset: (reason) => ({
        type: actions.SESSION_RESET,
        payload: {reason},
    }),
    sessionResetSuccess: (reason) => ({
        type: actions.SESSION_RESET_SUCCESS,
        payload: {reason},
    }),
    sessionResetRemote: (reason) => ({
        type: actions.SESSION_RESET_REMOTE,
        payload: {reason},
    }),
    selected_userpermissions: (data) => ({
        type: actions.SELECT_USERPERMISSIONS,
        payload: {data},
    }),
    ipaddress: (data) => ({
        type: actions.IPADDRESS,
        payload: {data},
    }),
    userInfoUpdated: (tokens) => ({
        type: actions.USERINFO_UPDATE_REQUEST,
        payload: {tokens},
    }),
    userInfoUpdatedSuccess: (user) => ({
        type: actions.USERINFO_UPDATE_SUCCESS,
        payload: {user},
    }),
    userUpdate: (data = {}) => ({
        type: actions.USER_UPDATE,
        payload: data,
    }),
};
export default actions;
